import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader } from "./CurrencyMasterPage";

export default function EntitiesPage() {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        api.get("/entities").then(({ data }) => setRows(data));
    }, []);
    return (
        <div data-testid="entities-page">
            <PageHeader
                title="Entities"
                eyebrow="Masters"
                description="Five operating entities are pre-seeded. Switch the entity from the topbar to filter all transactions."
            />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                {rows.map((e) => (
                    <div key={e.id} className="bg-white border border-slate-200 p-5" data-testid={`entity-card-${e.code}`}>
                        <div className="text-[10px] uppercase tracking-widest text-slate-500">{e.country}</div>
                        <div className="text-lg font-semibold tracking-tight mt-1">{e.name}</div>
                        <div className="font-mono text-[11px] text-slate-500 mt-3">CODE · {e.code}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
